export default "__VITE_ASSET__C7jI3Tig__"